import { render, staticRenderFns } from "./ProductInfo_list.vue?vue&type=template&id=62746430&scoped=true"
import script from "./ProductInfo_list.vue?vue&type=script&lang=js"
export * from "./ProductInfo_list.vue?vue&type=script&lang=js"
import style0 from "./ProductInfo_list.vue?vue&type=style&index=0&id=62746430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62746430",
  null
  
)

export default component.exports